import UserListPage from "../admin/UserListPage";
import Dashboard from "../admin/Dashboard";
import ProductList from "../admin/ProductList";
import ProductPriceLogsPage from "../admin/ProductPriceLogsPage";
import InventoryLogsPage from "../admin/InventoryLogsPage";
import InventoryPage from "../admin/InventoryPage";
import AdminCalendarPage from "../admin/CalendarPage";
import UnderConstructionPage from "../components/CommonComponents/UnderConstructionIcon";
import Analytics from "../admin/Analytics";
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../components/CommonComponents/MainLayout";
import TransactionList from "../components/transaction/TransactionList";
import Reports from "../admin/Reports";
import ExpensesPage from "../components/pos/pages/ExpensesPage";
import WasteReportsPage from "../components/waste/WasteReportsPage";
import UserManualPage from "../components/manual/UserManualPage";
import { Navigate } from "react-router-dom";

export const adminRoutes = [
    {
        path: "/admin/branches",
        element: <Navigate to="/admin/dashboard" replace />,
    },
    {
        path: "/admin/pre-release-tracker",
        element: <Navigate to="/admin/dashboard" replace />,
    },
    {
        path: "/admin/user-list",
        element: <ProtectedRoute allowedRoles={[1]} disallowManager><MainLayout><UserListPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/dashboard",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Dashboard /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/transactions",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><TransactionList restrictToToday={false} showSummary={true} useExpensesPagination={true} /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/expenses",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ExpensesPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/waste-requests",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><WasteReportsPage mode="admin" /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/products",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ProductList /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/product-price-logs",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ProductPriceLogsPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/inventory",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><InventoryPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/inventory-logs",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><InventoryLogsPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/calendar",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><AdminCalendarPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/analytics",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Analytics /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/reports",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Reports /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/manual",
        element: <ProtectedRoute allowedRoles={[1]}><UserManualPage /></ProtectedRoute>,
    },
    {
        path: "/admin/settings",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><UnderConstructionPage /></MainLayout></ProtectedRoute>,
    },
];
